import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import "./App.css";

function App() {
  return (
    <UserProvider>
      <Router basename={process.env.PUBLIC_URL || "/"}>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;
